/**
 * Checks if the provided value is a plain JavaScript object.
 *
 * @param {*} obj The value to check.
 * @returns {obj is Record<string, unknown>} A boolean indicating whether or
 * not the provided value is a plain object.
 */
export function isObject(obj) {
  return !!obj && Object.prototype.toString.call(obj) === "[object Object]";
}

/**
 * Checks if the user has indicated a preference for reduced motion.
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 *
 * @returns {boolean}
 */
export const prefersReducedMotion = (() => {
  const media =
    "matchMedia" in window
      ? window.matchMedia("prefers-reduced-motion")
      : { matches: false };
  return () => media.matches;
})();

/**
 *
 * @param {number} n
 * @param {number} d
 * @returns {number}
 */
export function round(n, d = 4) {
  return Math.round(n * 10 ** d) / 10 ** d;
}

/**
 * Generates a unique id optionally prefixed with the provided string
 *
 * @param {string|undefined} prefix Optional. The id prefix.
 * @returns {string} A unique id.
 */
export const uniqueId = (() => {
  let index = -1;
  return (prefix = "id") => {
    const id =
      typeof crypto.randomUUID === "function" ? crypto.randomUUID() : ++index;
    return `${prefix}-${id}`;
  };
})();
